import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';
import getSortedAuthMethods from 'components/AccountLinkReminder/getSortedAuthMethods';
import {
  DEBUG_ALWAYS_SHOW_ACCOUNT_LINK_REMINDER,
  DEBUG_FLAGS,
} from 'feature-flags';
import AuthStatus from './AuthStatus';

export function AccountLinkReminderReady({
  authMethods,
  onRequestClose,
}: Props) {
  const methods = useMemo(() => getSortedAuthMethods(authMethods ?? []), [authMethods]);

  return (
    <div>
      <h2 className="heading heading--2">
        Review your login methods
      </h2>
      <p>
        It looks like you've only linked your account to one login method
        {DEBUG_FLAGS[DEBUG_ALWAYS_SHOW_ACCOUNT_LINK_REMINDER]
        && ' (or this release was built in dev mode to show this modal on startup)'}
        .
        {' '}
        You can change this here, if you'd like.
      </p>
      <div>
        <ul>
          {methods.map(method => (
            <li key={method}>
              <h3 className="heading heading--3">
                {method}
              </h3>
              <AuthStatus
                method={method}
              />
            </li>
          ))}
        </ul>
      </div>
      <div className="buttons">
        <button
          className="button button--primary"
          type="button"
          onClick={onRequestClose}
        >
          OK
        </button>
      </div>
    </div>
  );
}

type OwnProps = {
  onRequestClose: () => void,
};

const mapStateToProps = ({
  settings: { authMethods, data },
}: IAppState) => ({
  authMethods,
  data,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(AccountLinkReminderReady);
